<template>
  <div>
    <b-card>
      <b-card-title>
        <feather-icon icon="PlusIcon" size="20" class="mr-50" />
        Nueva Evaluación de Brecha
      </b-card-title>

      <gap-form
        :form-data="formData"
        :is-edit="false"
        @submit="handleSubmit"
        @cancel="handleCancel"
      />
    </b-card>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { BCardTitle } from 'bootstrap-vue'
import { useRouter } from '@core/utils/utils'
import GapForm from '../shared/GapForm.vue'
import { useLambda } from '@/views/habit/awsLambda'
import { oid, date } from '@/helpers/mongoHelpers'
import useNotifications from '@/composables/useNotifications'
import { hasPermission } from '@/composables/usePermission'
import i18n from '@/libs/i18n'
import store from '@/store'

export default {
  name: 'GapAdd',
  components: {
    GapForm,
    BCardTitle,
  },
  setup() {
    const { router } = useRouter()
    const { createItem } = useLambda()
    const { showSuccessMessage, showErrorMessage } = useNotifications()
    const { client, worker_id: userId } = store.state?.userStore?.userData

    const formData = ref({
      obligation_id: null,
      status: 'No implementado',
      evidence: '',
      gapDescription: '',
      actionPlan: '',
      responsible_id: null,
      deadline: null,
      planStatus: 'Pendiente',
    })

    const handleSubmit = async (data) => {
      if (!hasPermission('privacy-gap', 'create')) {
        showErrorMessage(i18n.t('message.you_are_not_authorized'))
        return
      }
      try {
        const payload = {
          ...data,
          client_id: oid(client.$oid),
          obligation_id: oid(data.obligation_id),
          responsible_id: data.responsible_id ? oid(data.responsible_id) : null,
          deadline: data.deadline ? date(data.deadline) : null,
          history: [{
            timestamp: new Date(),
            userId: oid(userId.$oid),
            action: 'created',
            changedFields: {},
          }],
        }

        await createItem({
          collection: 'gap',
          payload,
        })

        showSuccessMessage('Evaluación de brecha creada correctamente')
        router.push({ name: 'privacy-gap-list' })
      } catch (error) {
        console.log(error)
        showErrorMessage('Error al crear evaluación de brecha')
      }
    }

    const handleCancel = () => {
      router.push({ name: 'privacy-gap-list' })
    }

    return {
      formData,
      handleSubmit,
      handleCancel,
    }
  },
}
</script>
